module.exports = __webpack_public_path__ + "static/media/sf-test-6.ca694f25.mp3";